import classNames from 'classnames';
import {useCallback, useEffect, useRef, useState} from 'react';
import {TransformComponent, TransformWrapper, useControls} from 'react-zoom-pan-pinch';

const WrapperProps = {
    id: 'projection-map-image',
};

const InitialKey = WrapperProps.id;

const getContentClass = loading => classNames('image', {loading});

const getTransformComponentProps = loading => ({
    wrapperProps: WrapperProps,
    contentClass: getContentClass(loading),
});

const getTransformWrapperProps = disabled => ({
    disabled,
    centerOnInit: true,
});

const CenterImage = ({onLoad, children}) => {
    const controls = useControls();
    const controlsRef = useRef(controls);
    const [key, setKey] = useState(InitialKey);
    const handleLoad = useCallback(
        event => {
            const {
                naturalWidth: width = 0,
                naturalHeight: height = 0,
            } = event.target;

            onLoad(event);
            setKey(`${width}-${height}`);
        },
        [onLoad],
    );

    useEffect(
        () => {
            controlsRef.current.centerView(0, 0, null);
        },
        [key, controlsRef],
    );

    return children(handleLoad);
};

const PinchPanZoom = ({loading, disabled, onLoad, children}) => {
    const transformWrapperProps = getTransformWrapperProps(disabled);
    const transformComponentProps = getTransformComponentProps(loading);

    return (
        <TransformWrapper {...transformWrapperProps}>
            <TransformComponent {...transformComponentProps}>
                <CenterImage onLoad={onLoad}>
                    {children}
                </CenterImage>
            </TransformComponent>
        </TransformWrapper>
    );
};

export default PinchPanZoom;
